import { Button, ButtonReversed } from "shared/components/Button";
import BatchTextInputSection from "./BatchTextInputSection";
import BatchFileInputSection from "./BatchFileInputSection";
import { sentence } from "shared/types/Report";
import LoadingWithProgressBar from "shared/components/Loading";
import Modal from "shared/components/Modal";
import useSentenceBatchView from "features/homework/hooks/useSentenceBatchView";
import { BatchBackdrop, BatchModal, BatchHeader, BatchTitle, BatchDesc, BatchBody, BatchSection, BatchFooter } from "../homeworkUi";

interface SentenceBatchViewProps {
    list:sentence[],
    setList:React.Dispatch<React.SetStateAction<sentence[]>>,
    path: string,
    isOpen: boolean,
    onCancelClickHandler: () => void
}

const SentenceBatchView = ({ isOpen, onCancelClickHandler, path, list, setList }: SentenceBatchViewProps) => {
    const { fileList, setFileList, onChangeInputHandler, onSaveClickHandler, showProgress, uploadFileName, progress, isSaveSucceed, onSuccessModalConfirmHandler, isOpenErrorModal, onErrorModalCloseClickHandler, audioList, setAudioList, errorMessage } = useSentenceBatchView(list, setList, path, onCancelClickHandler);
    
    if (!isOpen) {
        return null;
    }

    return (
        <BatchBackdrop>
            <BatchModal>
                {showProgress ? <LoadingWithProgressBar title="파일 업로드" subTitle={uploadFileName} progress={progress}/> : null}
                <Modal isOpen={isSaveSucceed} onClose={onSuccessModalConfirmHandler} title="저장 성공" content="저장에 성공하였습니다"/>
                <Modal isOpen={isOpenErrorModal} onClose={onErrorModalCloseClickHandler} title="ERROR" content={errorMessage}/>
                <BatchHeader>
                    <BatchTitle>문장 일괄 등록</BatchTitle>
                    <BatchDesc>한 줄에 하나씩 입력하세요. 이미지와 음원은 선택 사항이며, 개수가 맞을 때만 함께 저장됩니다.</BatchDesc>
                </BatchHeader>
                <BatchBody>
                    <BatchSection>
                        <BatchTextInputSection 
                            label="문장" 
                            items={[{ label: "영어", name: "sentence" }, { label: "한국어", name: "kor" }]} 
                            onChangeHandler={onChangeInputHandler} 
                        />
                    </BatchSection>
                    <BatchSection>
                        <BatchFileInputSection 
                            label="이미지" 
                            accept="image"
                            fileList={fileList} 
                            setFileList={setFileList} 
                        />
                        <BatchFileInputSection 
                            label="음원" 
                            accept="audio"
                            fileList={audioList} 
                            setFileList={setAudioList} 
                        />
                    </BatchSection>
                </BatchBody>
                <BatchFooter>
                    <ButtonReversed name="닫기" onButtonClick={onCancelClickHandler} />
                    <Button name="저장" onButtonClick={onSaveClickHandler} />
                </BatchFooter>
            </BatchModal>
        </BatchBackdrop>
    );
}

export default SentenceBatchView;
